const sizes = { sm: 44, md: 52, lg: 72 }

export default function Logo({ size = 'md', variant = 'dark' }) {
  const px = sizes[size] || sizes.md
  const src = variant === 'light' ? '/osteo3d-logo-white.png' : '/osteo3d-logo.png'
  return (
    <a href="https://www.osteo3d.com" target="_blank" rel="noopener noreferrer">
      <img
        src={src}
        alt="Osteo3D"
        style={{ height: px, width: 'auto' }}
        className="object-contain"
      />
    </a>
  )
}
